import { useState, useEffect } from "react";

/**
 * timeOver method is called after all time has ended
 * totalTime is total Time duration in seconds
 */
 function LLDInterviewCountdownTimer({totalTime=60*60, timeOver}) {
  const [timeLeft, setTimeLeft] = useState(totalTime); // 60 minutes in seconds
  

  useEffect(() => {
    if (timeLeft <= 0) {
      if (timeOver) timeOver(); // Call timeOver callback when time reaches 0
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer); // Cleanup interval on unmount
  }, [timeLeft]); // Depend on timeLeft to update correctly

  // Convert seconds to minutes and seconds format
  // ????? for 1 minute show minute not minutes ??????
  let timeLeftStr =
    timeLeft >= 60
      ? `${Math.floor(timeLeft / 60)} Minutes Left`
      : `${timeLeft} Seconds Left`;
  if(timeLeft<120 && timeLeft>=60)
    timeLeftStr=timeLeftStr.replace("Minutes", "Minute")

  const displayTime=timeLeftStr

  return (
    <div className="text-center">
      { timeLeft>=60*5 && 
      <div className=" px-12 py-6 rounded-lg
       bg-teal-500  text-white">{displayTime}</div>
      }
      {
        timeLeft<60*5 && 
        <div className=" px-12 py-6 rounded-lg
         bg-red-500  text-white">{displayTime}</div>
      }
    </div>
  );
}

export {LLDInterviewCountdownTimer};